import { AppState } from '@chegg-wt/core/state'
import { createSelector } from 'reselect'
import { Folder } from '@chegg-wt/core/types/folders'
import { projectTypeNameSelector } from '../projects/selectors'
import { indexFromModalDataSelector } from '../modals/selectors'
import { FolderForSelectBox } from './types'

export const foldersDataSelector = (state: AppState) => state.folders.currentFolders

export const folderSelector = (state: AppState, props: { index: number }) =>
  state.folders.currentFolders[props.index] || { name: '', id: 0, public: false }

export const folderNameByIndexSelector = createSelector(
  folderSelector,
  (folder) => folder?.name ?? ''
)
export const folderIdSelector = (state: AppState) => state.folders.id

export const folderNameSelector = createSelector(
  foldersDataSelector,
  folderIdSelector,
  (folders, selectedFolderKey): string => {
    if (!selectedFolderKey) return ''

    const guess = folders.find((folder) => folder.id === selectedFolderKey)

    if (guess == null) return ''

    return guess.name
  }
)

export const titleSelector = createSelector(
  projectTypeNameSelector,
  folderNameSelector,
  (projectTypeName, folderName): string => folderName || projectTypeName
)

export const folderIndexSelector = createSelector(
  foldersDataSelector,
  folderIdSelector,
  (folders, selectedFolderKey): number =>
    selectedFolderKey
      ? folders.findIndex((folder) => folder.id === selectedFolderKey)
      : -1
)

export const isFolderSelectedSelector = createSelector(
  folderSelector,
  folderIdSelector,
  (folder, selectedFolderKey): boolean =>
    selectedFolderKey ? folder.id === selectedFolderKey : false
)

export const foldersForSelectBoxSelector = createSelector(
  [foldersDataSelector],
  (folders): FolderForSelectBox[] =>
    folders.map((folder) => ({
      id: folder.id,
      name: folder.name,
    }))
)

export const folderDataFromModalDataSelector = createSelector(
  [indexFromModalDataSelector, foldersDataSelector],
  (folderIndex, foldersData): Folder => foldersData[folderIndex]
)
